import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { PageHeaderCustom } from '../../components';
import { formItemLayout, tailFormItemLayout } from '../../utils/formLayouts';
import PaymentForm from './PaymentForm';

const EditAndCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();

  return (
    <>
      <PageHeaderCustom title={t(`payments.create.paymentInfo`)} />
      <PaymentForm
        id={id}
        formItemLayout={formItemLayout}
        tailFormItemLayout={tailFormItemLayout}
        history={history}
      />
    </>
  );
};

export default EditAndCreate;
